import handler from 'api/handler'

const prefix = '/public/mandir'

const mandir = {
  fetchAll: args => handler({ method: 'get', url: `${prefix}/fetch`, args }),
  create: args => handler({ method: 'post', url: `${prefix}/submit`, args, isFile: true }),
}

export default mandir

